import { createBreakpoints } from '@mui/system';
import globalMuiTheme from '../global/global-mui-theme';
import overrideTypography from '../utils/overrideTypography';
const buildMuiTheme = (brandConstants, typography) => {
    const baseMuiTheme = {
        spacing: 4,
        palette: {
            common: {
                black: brandConstants.colors.black,
                white: brandConstants.colors.white,
            },
            primary: {
                main: brandConstants.colors.primary,
                light: brandConstants.colors.primary_light,
                contrastText: brandConstants.colors.white,
            },
            secondary: {
                main: brandConstants.colors.secondary,
                light: brandConstants.colors.third,
                dark: brandConstants.colors.secondary_dark,
                contrastText: brandConstants.colors.white,
            },
            text: {
                primary: brandConstants.colors.primary_text,
                secondary: brandConstants.colors.secondary_light,
                disabled: brandConstants.colors.light_grey,
            },
            background: {
                ...globalMuiTheme.palette.background,
                default: brandConstants.colors.white,
                alternate: brandConstants.colors.bg_alternative,
                header: brandConstants.colors.primary_dark,
            },
            ...(brandConstants.colors.error && {
                error: {
                    main: brandConstants.colors.error,
                },
            }),
            primaryDisabled: {
                main: brandConstants.colors.primary_disabled,
            },
            slider: brandConstants.colors.slider,
            textHeader: brandConstants.colors.text_header,
            textAccent: brandConstants.colors.text_accent,
        },
        typography: {
            fontFamily: brandConstants.fontFamilies.primary,
            fontFamily2: brandConstants.fontFamilies.primary_bold,
            fontFamily3: brandConstants.fontFamilies.heavy,
            fontSize: 10,
            htmlFontSize: 10,
            fontWeightBold: 600,
            ...overrideTypography(typography, {
                button: {
                    fontSize: brandConstants.fontSizes.xs,
                    textTransform: 'initial',
                },
                body1: {
                    fontSize: brandConstants.fontSizes.md,
                    fontFamily: brandConstants.fontFamilies.light,
                    [`@media (max-width:${brandConstants.screens.sm}px)`]: {
                        fontSize: brandConstants.fontSizes.md,
                    },
                },
                body2: {
                    fontSize: brandConstants.fontSizes.sm,
                    fontFamily: brandConstants.fontFamilies.light,
                    [`@media (max-width:${brandConstants.screens.sm}px)`]: {
                        fontSize: brandConstants.fontSizes.xs,
                    },
                },
                h1: {
                    fontSize: brandConstants.fontSizes.xxl,
                    letterSpacing: 3,
                    color: brandConstants.colors.primary,
                    fontFamily: brandConstants.fontFamilies.primary,
                },
                h2: {
                    fontSize: brandConstants.fontSizes.xxl,
                    color: brandConstants.colors.primary,
                    fontWeight: 600,
                    fontFamily: brandConstants.fontFamilies.primary,
                },
                h3: {
                    fontSize: brandConstants.fontSizes.xxl,
                    marginBottom: '1rem',
                    fontFamily: brandConstants.fontFamilies.primary,
                    [`@media (max-width:${brandConstants.screens.md}px)`]: {
                        fontSize: brandConstants.fontSizes.xl,
                    },
                },
                h4: {
                    fontSize: brandConstants.fontSizes.xl,
                    fontFamily: brandConstants.fontFamilies.primary,
                    [`@media (max-width:${brandConstants.screens.md}px)`]: {
                        fontSize: brandConstants.fontSizes.lg,
                    },
                },
                h5: {
                    fontSize: brandConstants.fontSizes.lg,
                    lineHeight: 1.5,
                    fontWeight: 600,
                    fontFamily: brandConstants.fontFamilies.primary,
                },
                h6: {
                    fontFamily: brandConstants.fontFamilies.light,
                },
                subtitle1: {
                    fontSize: brandConstants.fontSizes.md,
                    fontFamily: brandConstants.fontFamilies.light,
                    [`@media (max-width:${brandConstants.screens.sm}px)`]: {
                        fontSize: brandConstants.fontSizes.sm,
                    },
                },
                subtitle2: {
                    fontFamily: brandConstants.fontFamilies.light,
                    fontSize: brandConstants.fontSizes.sm,
                },
                caption: {
                    fontFamily: brandConstants.fontFamilies.light,
                    fontSize: brandConstants.fontSizes.sm,
                    [`@media (max-width:${brandConstants.screens.md}px)`]: {
                        fontSize: brandConstants.fontSizes.xs,
                    },
                },
                captionHeavy: {
                    captionHeavy: true,
                },
                helpingText: {
                    helpingText: true,
                },
                sectionTitle: {
                    fontSize: brandConstants.fontSizes.xl,
                    fontFamily: brandConstants.fontFamilies.primary,
                    [`@media (max-width:${brandConstants.screens.md}px)`]: {
                        fontSize: brandConstants.fontSizes.lg,
                    },
                },
            }),
            fontXXL: brandConstants.fontSizes.xxl,
            fontXL_LG: brandConstants.fontSizes.xl_lg,
            fontXL: brandConstants.fontSizes.xl,
            fontLG: brandConstants.fontSizes.lg,
            fontMD: brandConstants.fontSizes.md,
            fontSM: brandConstants.fontSizes.sm,
            fontXS: brandConstants.fontSizes.xs,
            fontXXS: brandConstants.fontSizes.xxs,
        },
        breakpoints: createBreakpoints({
            values: brandConstants.screens,
        }),
    };
    return baseMuiTheme;
};
export default buildMuiTheme;
//# sourceMappingURL=base-mui-theme.js.map